import styled from 'styled-components';

export const Title = styled.h1`
  font-family: 'Staatliches';
  color: #EB8A26;
  line-height: 60px;
  font-size: 70px;
  max-width: 600px;
  margin:auto auto 25px auto;
`;

export const IntroText = styled.p`
  font-family: 'Raleway', sans-serif;
  color: white;
  font-weight: 400;
  max-width: 800px;
  font-size: 18px;
  line-height: 1.6;
  text-align: center;
  margin: auto;
`;

export const ContactLink = styled.a`
  font-family: 'Raleway', sans-serif;
  display: block;
  margin: 16px;
  text-align: center;
  font-weight: 400;
  max-width: 300px;
  font-size: 18px;
  color: white;
  text-decoration: underline;

   &:hover {
   cursor: pointer;
  }
`

export const CodeLink = styled.a`
  font-family: 'Raleway', sans-serif;
  display: block;
  margin: 16px;
  text-align: center;
  font-weight: 400;
  font-size: 18px;
  color: white;
  max-width: 300px;
  text-decoration: underline;

   &:hover {
   cursor: pointer;
  }
`

export const Button = styled.button`
  background-color: #576B7A;
  font-weight: bold;
  padding: 16px 30px 16px 30px;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  border: none;
  display: block;
  margin: auto;
  width: auto;
`;

export const LogoStyle = styled.img`
  width: 250px;
  height: auto;
  margin: 25px 0 25px 0;
  @media(max-width: 900px) {
    width: 250px;
    height: 45px;
  }
`;

export const InputSubmit = styled.input.attrs(props => ({
  type: "submit",
}))`
  background-color: #576B7A;
  font-weight: bold;
  padding: 16px 30px 16px 30px;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  border: none;
  display: block;
  margin: auto;
  width: auto;
`

export const InputText = styled.input.attrs(props => ({
  type: "text",
}))`
  background-color: white;
  font-size: 16px;
  font-weight: bold;
  height: 48px;
  border-radius: 8px;
  border: none;
  text-align: center;
  font-family: 'Raleway', sans-serif;
  font-weight: 400;
  color: #9F9F9F;
  width: 40%;
  margin-bottom: 20px;
`

export const Position = styled.div`
  height: 100%;
`

export const Form = styled.form`
  margin-top: 50px;
`

export const LinksContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`